import axios from "axios";
import { LOG_OUT } from "../Page/LogIn/types";
// console.log(
//   process.env.REACT_APP_BASE_URL_LOCAL,
//   "<<<<<<<<<<<<<<<<<<<<<<REACT_APP_BASE_URL_LOCAL"
// );
export const axiosInstance = axios.create({
  // baseURL: "http://192.168.1.246:4000/api/v1",

  baseURL: `${process.env.REACT_APP_BASE_URL_LOCAL}api/v1`,
  headers: {
    "Content-Type": "application/json",
  },
  
});

export const getProtectedInstance = () => {
  const token = localStorage.getItem("token");

  // console.log('env path',process.env.REACT_APP_BASE_URL_LOCAL)
  // console.log(token);
  const protectedAxiosInstance = axios.create({
    // baseURL: "http://192.168.1.246:4000/api/v1",

    baseURL: `${process.env.REACT_APP_BASE_URL_LOCAL}api/v1`,

    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  protectedAxiosInstance.interceptors.request.use(
    (config: any) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  protectedAxiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      // console.log("hamro res error", error);
      const originalRequest = error?.config;
      // console.log("axios instance ko", error.response);
      if (error.response.status === 401) {
        const refreshToken = localStorage.getItem("refreshToken");
        return axiosInstance
          .get("/auth/refresh", {
            headers: {
              Authorization: "Bearer " + refreshToken, //the token is a variable which holds the token
            },
          })
          .then((res) => {
            // console.log("refreshtoken le access", res);
            if (res.data.statusCode === 200) {
              // 1) put token to LocalStorage
              const token = localStorage.setItem(
                "token",
                res.data.data.access_token
              );

              // 2) Change Authorization header
              protectedAxiosInstance.defaults.headers.common["Authorization"] =
                "Bearer " + token;

              // 3) return originalRequest object with Axios.
              return protectedAxiosInstance(originalRequest);
            }
          })
          .catch((err) => {
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("role");
            // dispatch({ type: LOG_OUT })
            return Promise.reject(err);
          });
      }

      // return Error object with Promise
      return Promise.reject(error);
    }
  );
  return protectedAxiosInstance;
};


